import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".login-callout-container{align-items:center;background-color:#f8f8f8;border-radius:8px;flex-direction:row;justify-content:space-between;padding:24px}@media only screen and (min-width:1440px){.login-callout-container{padding:24px 16px}}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
